import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useHistory, useParams } from "react-router";
import { RouteComponentProps } from "react-router-dom";
import useFlash from "go-alert/AlertMessage";
import handleError from "go-app/services/errors";
import { useBrowserTabTitle } from "go-core/components/BrowserTab/useBrowserTabTitle";
import { LoadingContainer } from "go-core/components/Loading";
import { selectOrganization } from "go-security/services/organizations/selectors";
import { ApplicationApi, ApplicationTemplateApi } from "../../../../../../../../services/Api/Organization/types";
import { api } from "../../../../../../../../services/Api/api";
import InstalledApps from "../../components/Apps/InstalledApps";
import OrganizationAppsEditPage from "../Edit";

interface MatchParams {
	appId: string;
}

const OrganizationAppsIndexPage = (props: RouteComponentProps) => {
	const [apps, setApps] = useState<undefined | ApplicationApi[]>(undefined);
	const history = useHistory();
	const [appTemplates, setAppTemplates] = useState<undefined | ApplicationTemplateApi[]>(undefined);
	const { addFlash } = useFlash();
	const { t } = useTranslation();
	const { handleChangeTabTitle } = useBrowserTabTitle();
	const { appId } = useParams<MatchParams>();
	const organization = useSelector(selectOrganization);
	const modalClosedPathname = `/${organization.id}/apps/active`;

	useEffect(() => {
		handleChangeTabTitle(`${t("modules.app.field.active.title")} | ${t("modules.app.header.title")}`);
		Promise.all([
			api.organization().getApps({ include: "settings", size: 100 }),
			api.organization().getAppTemplates(),
		])
			.then((res) => {
				setApps(res[0]);
				setAppTemplates(res[1]);
			})
			.catch((err) => {
				handleError.alert(err, addFlash);
			});
	}, []);

	const handleUninstall = (app: ApplicationApi) => {
		history.push(modalClosedPathname);
		setApps(apps?.filter((f) => f.id !== app.id));
	};

	const handleUpdate = (app: ApplicationApi) => {
		const currApps = apps;
		if (currApps) {
			const currentAppIndex = currApps.findIndex((f) => f.id === app.id);
			currApps[currentAppIndex] = app;
			setApps([...currApps]);
		}
	};

	const onHideModal = () => history.push(modalClosedPathname);

	if (!apps || !appTemplates) {
		return <LoadingContainer />;
	}

	return (
		<>
			<InstalledApps
				handleUpdate={handleUpdate}
				handleUninstall={handleUninstall}
				routeProps={props}
				appTemplates={appTemplates}
				installedApps={apps}
			/>
			{appId && (
				<OrganizationAppsEditPage
					handleUpdate={handleUpdate}
					handleUninstall={handleUninstall}
					routeProps={props}
					installedApps={apps}
					appConfigs={appTemplates}
					appId={appId}
					onHideModal={onHideModal}
				/>
			)}
		</>
	);
};
export default OrganizationAppsIndexPage;
